export default "__VITE_ASSET__N6N4m24t__"